import React, {Component} from 'react';
import {
    Button,
    Row,
    Col,
} from '@sketchpixy/rubix'

class ExamResumeOrNew extends Component {
    constructor(props) {
        super(props)
        console.log(props)
        this.state = {
            status: props.status? props.status: ""
        }
    }
    componentDidMount() {

    }
    render() {
        const {
            onClose
          } = this.props
          const { status } = this.state;
          let message = "Please select";
          let warning = "";
          let btn1Text = "";
          let btn2Text = "";
          let param = "";
          if (status) {
            message = "It seems that you have already begun this exam, do you want to start over?"
            warning = "Restarting the exam will erase their previous responses and generate a new DBQ";
            btn1Text = "Cancel"
            btn2Text = "Start over";
            param = "sign";
          } else {
            message = "It seems that you have already begun this exam, do you want to start over?"
            btn1Text = "Start over"
            btn2Text = "Resume";
            param = "exam";
          }

        return (
            <div className="overlay-msg" onClick={e => {onClose({src: "", param:""})}}>
                <div className="overlay-box">
                    <h4 style={{color: "#555"}}>{message}</h4>
                    <h5 style={{color: "#F12F39", fontWeight: 'bold'}}>{warning}</h5>
                    <br /><br />
                    <Row className="backnext-btn-div">
                        <Col xs={6}  className='text-center'>
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="back-btn ripple"
                                onClick={e => {onClose({src: "first", param})}}
                            >{btn1Text}</Button>
                        </Col>
                        <Col xs={6} 
                            className='text-center'>                        
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="next-btn ripple"
                                onClick={e => {onClose({src: "second", param})}}
                            >{btn2Text}</Button>
                                                
                            
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default ExamResumeOrNew